module.exports = __webpack_public_path__ + "static/img/vhost-support.d4f03f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/vhost-support.png
// module id = IYi7
// module chunks = 1